import moment from "moment";
import { MOMENT_LONG_DATE_FORMAT } from "../../../shared/constants";

export const COLUMNS = [
    {
        Header: "Bin",
        accessor: "description",
    },
    {
        Header: "Arrived At",
        accessor: "arrivedAt",
        Cell: (row) => {
            return moment(row.value).format(MOMENT_LONG_DATE_FORMAT);
        },
    },
];
